export default __webpack_public_path__ + "static/media/feed_desktop_banner.e1100ed7.png";